import { Tag } from "antd";
import type { ColumnsType } from "antd/es/table";
import { langCommon, langPage, langTableColumns } from "../../../locales";
import { floatNumberInThousands } from "../../../utils/tools"
import { FormConfigType } from "../../../components/editForm";

const langRecharge = langPage?.amount;
const lang = langPage?.amount?.balanceLog;


export const DEFAULT_QUERY_DATA = {
    Date: null,
    DateStart: null,
    DateEnd: null,
    Email: null,
    MemberId: null,
    Scene: null,
    Status: null,
    TrackId: null,
}

export const generateQueryFormConfig = (props: any): FormConfigType => {
    const { options: { scenceOptions, statusOptions, trackOptions } } = props;

    return [
        {
            title: lang?.daily,
            type: "rangePicker",
            field: "Daily",
            fields: ["DateStart", "DateEnd"],
            allowClear: true,
            style: { width: 240 }
        },
        {
            title: langRecharge?.email,
            type: "input",
            field: "Email",
            allowClear: true,
        },
        {
            title: langRecharge?.memberId,
            type: "input",
            field: "MemberId",
            allowClear: true,
        },
        {
            title: lang?.scene,
            type: "select",
            field: "Scene",
            allowClear: true,
            style: { width: 180 },
            options: scenceOptions,
        },
        {
            title: langCommon?.status,
            type: "select",
            field: "Status",
            allowClear: true,
            options: statusOptions,
        },
        {
            title: lang?.track,
            type: "select",
            field: "TrackId",
            allowClear: true,
            options: trackOptions,
        },
    ];
}


const renderPrice = (val: number | string) => {
    return floatNumberInThousands(val) || ''
}

export const generateTableColumns = (props: any): ColumnsType => {

    return [
        {
            title: '编号',
            dataIndex: "Id",
        },
        {
            title: langRecharge?.memberId,
            dataIndex: "MemberId",
        },
        {
            title: langRecharge?.email,
            dataIndex: "Email",
            render(value, record, index) {
                return value || record.Member?.Email
            },
        },
        {
            title: lang?.daily,
            dataIndex: "Daily",
        },
        {
            title: lang?.scene,
            dataIndex: "SceneString",
        },
        {
            title: lang?.track,
            dataIndex: "Track",
            align: "center",
            render(value, record, index) {
                return record.TrackId === 1 ? <Tag color="processing">{value}</Tag> : <Tag color="red">{value}</Tag>
            },
        },
        {
            title: lang?.amount,
            dataIndex: "Amount",
            render: renderPrice
        },
        {
            title: lang?.before,
            dataIndex: "Before",
            render: renderPrice
        },
        {
            title: lang?.after,
            dataIndex: "After",
            render: renderPrice
        },
        {
            title: langRecharge?.walletType,
            dataIndex: "WalletType",
            render: (val) => {
                return val === 1 ? langRecharge?.walletType1 : ''
            }
        },
        {
            title: langCommon?.status,
            dataIndex: "StatusString",
        },
        {
            title: '备注',
            dataIndex: "Remark",
            width: 200
        },
        {
            title: lang?.describe,
            dataIndex: "Describe",
            width: 200
        },
        {
            title: langTableColumns?.CreatedAtString,
            dataIndex: "CreatedAtString",
        },
    ]
}
